module.exports = __webpack_public_path__ + "static/media/fig.b76d5061.jpg";